import api from '../../app/axios';

export type PublicSeoResponse = {
  locale: string;
  market?: string;
  pageType: string;
  seo?: {
    title?: string;
    description?: string;
    path?: string;
    type?: string;
    image?: string;
    ogImage?: string;
    isIndexable?: boolean;
  };
  robots?: {
    index?: boolean;
    follow?: boolean;
    nosnippet?: boolean;
    noarchive?: boolean;
    noimageindex?: boolean;
  };
  hreflang?: Record<string, string>;
  structuredData?: object[] | object;
  entity?: Record<string, unknown> | null;
  fallbackUsed?: boolean;
  translationStatus?: string;
  isIndexable?: boolean;
};

const safeGet = async (path: string, signal?: AbortSignal) => {
  try {
    const response = await api.get<PublicSeoResponse>(path, { signal });
    return response.data;
  } catch {
    return null;
  }
};

export const publicSeoApi = {
  getPage: (pageType: 'home' | 'about' | 'contact' | 'packages' | 'destinations' | 'articles', signal?: AbortSignal) =>
    safeGet(`/seo/pages/${pageType}`, signal),
  getPackage: (slug: string, signal?: AbortSignal) =>
    safeGet(`/seo/packages/${encodeURIComponent(slug)}`, signal),
  getDestination: (slug: string, signal?: AbortSignal) =>
    safeGet(`/seo/destinations/${encodeURIComponent(slug)}`, signal),
  getArticle: (slug: string, signal?: AbortSignal) =>
    safeGet(`/seo/articles/${encodeURIComponent(slug)}`, signal),
};

export type PublicSeoPageType = Parameters<typeof publicSeoApi.getPage>[0];
